var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBrFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  height: 32,
  width: 32
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#009b3a",
  d: "M32 24a3.556 3.556 0 0 1-3.556 3.556H3.556A3.556 3.556 0 0 1 0 24V8a3.556 3.556 0 0 1 3.556-3.556h24.888A3.556 3.556 0 0 1 32 8v16z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fedf01",
  d: "M29.092 16 16 25.888 2.908 16 16 6.111z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#002776",
  d: "M10.238 15.932a5.74 5.74 0 1 0 11.481 0 5.74 5.74 0 1 0-11.48 0"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#cbe9d4",
  d: "M10.913 13.233a5.694 5.694 0 0 0-.597 1.798c3.55-.258 8.37 1.681 10.439 4.085a5.753 5.753 0 0 0 .785-1.782c-2.553-2.496-7.038-4.115-10.627-4.101z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#88c9f9",
  d: "M10.667 16.207h.889v.889h-.89zm.889 1.778h.888v.889h-.888z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#55acee",
  d: "M13.333 16.207h.89v.889h-.89zm1.778.889H16v.889h-.889zm3.556 1.778h.889v.889h-.89zM16 19.763h.889v.889H16zm2.667-5.334h.889v.89h-.89z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#3b88c3",
  d: "M16.889 17.985h.889v.889h-.89z"
})));
export default SvgBrFlag;